<template>
  <div class="modal-message">
    <div class="card" v-loading="loading" element-loading-spinner="qc-spinner">
      <div class="card-header">
        <h4 class="card-title">Before you continue ...</h4>
      </div>
      <div class="card-content row">
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-sm-12">
              Qualification Check has recently updated our <a href="https://www.qualificationcheck.com/terms-and-conditions/" title="Qualification Check™ Terms & Conditions of Use" target="_blank">terms & conditions</a> as well as our <a href="https://www.qualificationcheck.com/terms-and-conditions#privacy-policy" title="Privacy Policy" target="_blank">privacy policy</a>.<br/>Please take a moment to review these and update your account settings as follows;
        
            </div>
          </div>
          <!-- <div class="form-group">
            <label class="col-sm-2 control-label">Keeping up to date</label>
            <div class="col-sm-10">
              Would you like Qualification Check to keep you informed of our latest institute coverage and new services?<br/>
              <el-radio name="marketing" v-model="marketing" v-validate="'required'" :label="true">Yes please</el-radio><br/>
              <el-radio v-model="marketing" :label="false">No thanks</el-radio>
              <small class="text-danger" v-show="errors.has('marketing')">
                <br/>Please let us know if you'd like to be kept up to date
              </small>
            </div>
          </div> -->
          <div class="form-group">
            <label class="col-sm-2 control-label">Terms and Privacy</label>
            <div class="col-sm-10">
              Please review the latest <a href="https://www.qualificationcheck.com/terms-and-conditions/" title="Qualification Check™ Terms & Conditions of Use" target="_blank">terms & conditions</a> for the use of our service, as well as our <a href="https://www.qualificationcheck.com/terms-and-conditions#privacy-policy" title="Privacy Policy" target="_blank">privacy policy</a> where you can find how we use and care for your personal data.<br/>
              I have read the above policies and;<br/>
              <el-radio name="tcs" v-model="tcs" v-validate="'required:true'" :label="false">Disagree</el-radio><br/>
              <el-radio v-model="tcs" :label="true">Agree</el-radio>
              <small class="text-danger" v-show="errors.has('tcs')">
                <br/>You must accept our terms & conditions in order to use our service.
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer row">    
        <div class="col-md-12">
          <button @click="submit()" class="btn btn-fill btn-wd pull-right">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'modal-message',
    data () {
      return {
        loading: false,
        marketing: null,
        tcs: false
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.loading = true;
            this.$api.getAccount()
              .then(response => {
                response.data.tcsVersion = this.$service.getLatestTcsVersion()
                response.data.marketing = this.marketing
                response.data.company = null
                response.data.institute = null
                this.$api.updateAccount(response.data)
                  .then(response => {
                    this.$api.refreshLogin()
                      .then(response => {
                        this.$store.commit('setTcsVersion', this.$service.getLatestTcsVersion())
                        this.$snotify.success("Thank you! Your selections have been updated.", "Success")
                        this.$modal.close()
                      })
                      .catch(error => {
                        console.log(error)
                        this.loading = false;
                      })
                  })
                  .catch(error => {
                    console.log(error)
                    this.loading = false;
                  })
              })
              .catch(error => {
                console.log(error)
                this.loading = false;
              })
          }
        })
      }
    }
  }
</script>

<style>
  .modal-message {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>